// =====================================================================
// packages/ui/icons.js — Sistema de ícones. SEM EMOJI, em lugar nenhum.
//
// Herdado do Monteiro de Moraes: um sprite SVG único, injetado uma vez no
// topo do documento, e ícones referenciados por <use>. Traços em
// currentColor, então o ícone assume a cor do texto automaticamente.
//
// Por que sprite e não emoji ou biblioteca de ícones via CDN:
//   - emoji renderiza diferente em cada SO e destoa de UI profissional;
//   - CDN de ícones = mais um request e mais uma origem no CSP;
//   - o sprite é inline, cacheado com o bundle, e funciona offline (PWA).
//
// USO:
//   import { montarSprite, icon } from '../../packages/ui/icons.js';
//   montarSprite();                       // 1x no boot
//   el.innerHTML = icon('imovel', 'ic-lg');
// =====================================================================

import spriteSvg from './icons-sprite.svg';   // esbuild --loader:.svg=text

let _montado = false;

/** Injeta o sprite no <body> (invisível). Idempotente. */
export function montarSprite() {
  if (_montado || typeof document === 'undefined') return;
  const holder = document.createElement('div');
  holder.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
  holder.setAttribute('aria-hidden', 'true');
  holder.innerHTML = spriteSvg;
  document.body.insertBefore(holder, document.body.firstChild);
  _montado = true;
}

/**
 * Devolve o HTML de um ícone.
 * @param {string} nome   sem o prefixo 'ic-'. Ex.: 'imovel', 'contrato'
 * @param {string} [cls]  classes extras: 'ic-lg', 'ic-xl'
 */
export function icon(nome, cls = '') {
  const id = ALIAS[nome] || `ic-${nome}`;
  return `<svg class="ic ${cls}" aria-hidden="true"><use href="#${id}"></use></svg>`;
}

// Vocabulário do domínio imobiliário mapeado para os símbolos que já
// existem no sprite do MdM. Trocar o desenho depois = mexer só aqui.
export const ALIAS = {
  dashboard:     'ic-dashboard',
  imovel:        'ic-hotel',
  imoveis:       'ic-hotel',
  contrato:      'ic-clipboard',
  contratos:     'ic-clipboard',
  inquilino:     'ic-hospedes',
  inquilinos:    'ic-hospedes',
  proprietario:  'ic-usuarios',
  proprietarios: 'ic-usuarios',
  cobranca:      'ic-receipt',
  cobrancas:     'ic-receipt',
  financeiro:    'ic-financeiro',
  repasse:       'ic-bank',
  repasses:      'ic-bank',
  pix:           'ic-money-bag',
  comprovante:   'ic-receipt',
  chamado:       'ic-wrench',
  chamados:      'ic-wrench',
  manutencao:    'ic-wrench',
  vistoria:      'ic-clipboard',
  despesa:       'ic-money-bag',
  relatorios:    'ic-relatorios',
  graficos:      'ic-graficos',
  mensagens:     'ic-mensagens',
  whatsapp:      'ic-mobile',
  configuracoes: 'ic-settings',
  usuarios:      'ic-usuarios',
  documentos:    'ic-archive',
  upload:        'ic-upload',
  download:      'ic-download',
  foto:          'ic-mobile',
  alerta:        'ic-warning',
  ok:            'ic-check',
  erro:          'ic-x-circle',
  atraso:        'ic-alarm',
  calendario:    'ic-calendar-plus',
  buscar:        'ic-search',
  novo:          'ic-plus',
  editar:        'ic-pencil',
  excluir:       'ic-trash',
  voltar:        'ic-back',
  chave:         'ic-key',
  cadeado:       'ic-lock',
  seguranca:     'ic-shield',
  grafico:       'ic-graficos',
  ocupacao:      'ic-bed',
  vago:          'ic-door',
  crescer:       'ic-target',
  pdf:           'ic-pdf',
  excel:         'ic-excel',
  email:         'ic-mail',
  sair:          'ic-door',

  // Fluxo do contrato. Nomes que a tela usa — sem alias, icon() cai num
  // símbolo inexistente e o botão fica com um buraco no lugar do ícone.
  busca:         'ic-search',
  config:        'ic-settings',
  documento:     'ic-archive',
  pessoa:        'ic-hospedes',
  dinheiro:      'ic-financeiro',
  check:         'ic-check',
  info:          'ic-info',
  ia:            'ic-robot',
  enviar:        'ic-share',

  tema:          'ic-bulb',
  sol:           'ic-sol',
  lua:           'ic-lua',
  ver:           'ic-eye',
  ocultar:       'ic-eye-off'
};

/** CSS do sistema de ícones. Injete uma vez (ou copie pro seu CSS). */
// Traço de 1.5 num ícone de 22px fica pesado; a 18px, com 1.6, o desenho
// respira e o texto ao lado volta a ser o protagonista. Ícone grande demais
// numa tela de trabalho compete com o dado — e o dado é o que importa.
export const ICON_CSS = `
svg.ic { display:inline-block; width:18px; height:18px; flex-shrink:0;
         stroke:currentColor; fill:none; stroke-width:1.6;
         stroke-linecap:round; stroke-linejoin:round; vertical-align:middle; }
svg.ic.ic-sm { width:14px; height:14px; }
svg.ic.ic-lg { width:24px; height:24px; }
svg.ic.ic-xl { width:32px; height:32px; }
svg.ic .fillc { fill:currentColor; stroke:none; }
.nav-item svg.ic { width:18px; height:18px; }

/* No celular o alvo do dedo cresce, mas o DESENHO não precisa crescer
   junto: quem aumenta é a área de toque (padding), não o traço. */
@media (pointer: coarse) {
  svg.ic { width:19px; height:19px; }
}
`;
